<template>
  <UninstallThankYou v-if="currentView === 'thankyou'"/>
  <UninstallCautions v-else @continue="handleContinue"/>
</template>

<script>
import UninstallThankYou from "./UninstallThankYou.vue";
import UninstallCautions from "./UninstallCautions.vue";

export default {
  name: 'UninstallConfirmation',
  components: {
    UninstallThankYou,
    UninstallCautions
  },
  data() {
    return {
      currentView: 'cautions',
    }
  },
  methods: {
    handleContinue() {
      this.currentView = 'thankyou';
    }
  },
}
</script>
